export default __webpack_public_path__ + "i18n/translations/translation-pt.b6e2bb18.json";